var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 130,
    viewBox: "0 0 152 130",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.751 129.885c39.288 0 77.543-29.113 77.543-68.401S102.5.885 63.213.885C23.925.885.037 9.901.037 49.19c0 39.287 34.427 80.696 73.714 80.696z",
    fill: "#EEF4F9",
    opacity: 0.607
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28 20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.8 45C.8 20.2 21 0 45.8 0 62 0 76.2 8.6 84.2 21.4",
    stroke: "#D9DCE1",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D9DCE1",
    fillRule: "nonzero",
    d: "m74.6 23 14.6 10.2L91 15.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8 45c0 24.8-20.2 45-45 45-16.6 0-31-9-38.8-22.4",
    stroke: "#D9DCE1",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D9DCE1",
    fillRule: "nonzero",
    d: "M16.4 66.4 2 55.6l-2 18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6 29h54.6c1.6 0 2.8 1.2 2.8 2.8v26.6c0 1.6-1.2 2.8-2.8 2.8H18.6c-1.6 0-2.8-1.2-2.8-2.8V31.8c0-1.6 1.2-2.8 2.8-2.8z",
    fill: "#56AAFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0478ED",
    fillRule: "nonzero",
    cx: 45.8,
    cy: 45,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0478ED",
    fillRule: "nonzero",
    cx: 25.2,
    cy: 45,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0478ED",
    fillRule: "nonzero",
    cx: 66.4,
    cy: 45,
    r: 3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayIcon);
export default __webpack_public_path__ + "static/media/payIcon.2eaa0dda31096e8a5c03b3c4348061db.svg";
export { ForwardRef as ReactComponent };